import { mediaUrl } from "../lib/api";

export default function MediaImg({ id, alt = "", className = "", imgClassName = "", ratio = null, children }) {
  const url = mediaUrl(id);
  return (
    <div className={`relative overflow-hidden bg-surface-muted ${className}`} style={ratio ? { aspectRatio: ratio } : undefined}>
      {url ? (
        <img src={url} alt={alt} loading="lazy" className={`w-full h-full ${ratio ? "object-cover" : ""} ${imgClassName}`} />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center">
          {children || <span className="font-serif italic text-faint">Belum ada gambar</span>}
        </div>
      )}
    </div>
  );
}

